import React from "react";
import { useHistory } from "react-router-dom";
import { C } from "./ipd-billing/constants";
import SvgIcon from "./ipd-billing/SvgIcon";
import ServiceMasterAdmin from "./ipd-billing/components/ServiceMasterAdmin";

// ─────────────────────────────────────────────────────────────────────────────
// Service Master admin (manager landing tile → /service-master)
//
// Tenant-wide billable service catalog: groups → classifications → service
// tariff rows (+ optional bed type / sample type), with meaningful unique_code
// identities shared across bed variants, rate/quantity modifiable flags, and
// CSV import. Consumed by Charge Capture and Corporate Rate Card, which patch
// against this catalog rather than duplicating it.
// Rendered inside IPDBillingAppShell (app navbar + background + permissions).
// ─────────────────────────────────────────────────────────────────────────────
export default function ServiceMaster() {
  const history = useHistory();

  return (
    <div style={{ minHeight: "calc(100vh - 140px)", background: C.bg }}>
      <style>{`
        @keyframes ipdFadeIn { from { opacity: 0; transform: translateY(4px); } to { opacity: 1; transform: none; } }
      `}</style>

      {/* Header */}
      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: "14px",
          padding: "18px 32px",
          background: C.card,
          borderBottom: `1px solid ${C.border}`,
        }}
      >
        <button
          onClick={() => history.push("/main-landing")}
          style={{
            display: "flex",
            alignItems: "center",
            gap: "6px",
            padding: "7px 12px",
            background: "#fff",
            border: `1px solid ${C.border}`,
            borderRadius: "8px",
            color: C.text,
            fontSize: "13px",
            fontWeight: 600,
            cursor: "pointer",
          }}
        >
          <SvgIcon name="back" size={16} color={C.text} />
          Home
        </button>

        <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
          <div
            style={{
              width: "34px",
              height: "34px",
              borderRadius: "9px",
              background: C.primary,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <SvgIcon name="package" size={18} color="#fff" />
          </div>
          <div>
            <div style={{ fontSize: "17px", fontWeight: 800, color: C.text }}>
              Service Master
            </div>
            <div style={{ fontSize: "11px", color: C.textSub, fontWeight: 600 }}>
              Billable service catalog · tenant-wide setup
            </div>
          </div>
        </div>
      </div>

      <div style={{ padding: "24px 32px" }}>
        <ServiceMasterAdmin />
      </div>
    </div>
  );
}
